import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./Hero.css";
import SEO from "../SEO";

export default function Hero() {
  useEffect(() => {
    AOS.init({ once: true, duration: 900, mirror: false });
  }, []);

  return (
    <>
      <SEO
        title="MZR Software – Premium Software Services"
        description="Custom ERP, POS, mobile apps, and web solutions delivered fast with transparent pricing and supportive service."
        image="https://mzrsoftware.com/assets/images/og-homepage.jpg"
        url="https://mzrsoftware.com/"
      />

      <div className="page-shell">
        <header className="site-header sticky-header" data-aos="fade-down">
          <div className="container header-inner">
            <nav className="nav-links">
              <a href="#services">Services</a>
              <a href="#why">Why Us</a>
              <a href="#portfolio">Portfolio</a>
              <a href="#testimonials">Testimonials</a>
            </nav>
            <Link to="/Contact/index" className="btn header-cta">
              Get Quote
            </Link>
          </div>
        </header>

        <main>
          <section className="hero-section" id="home">
            <div className="hero-overlay"></div>
            <div className="hero-decor hero-decor-1" />
            <div className="hero-decor hero-decor-2" />
            <div className="container hero-grid">
              <div className="hero-copy" data-aos="fade-right">
                <div className="hero-badges">
                  <span>100+ Projects</span>
                  <span>Fast Delivery</span>
                  <span>Affordable Pricing</span>
                </div>

                <h1>
                  Launch Your Business Website or ERP in Just{" "}
                  <span>A Few Days</span>
                </h1>
                <p>
                  Custom POS, ERP & Web Solutions designed for ambitious brands.
                  Launch faster, automate operations, and delight every user.
                </p>

                <div className="hero-actions">
                  <Link to="/Contact/index" className="btn btn-primary">
                    Get Instant Quote
                  </Link>
                  <Link to="/Portfolio/index" className="btn btn-secondary">
                    View Portfolio
                  </Link>
                </div>
              </div>

              <div className="hero-panel" data-aos="fade-left">
                <div className="hero-card hero-panel-card-1">
                  <div className="panel-icon">💼</div>
                  <h3>ERP Software</h3>
                  <p>
                    Centralized management for finance, inventory, payroll, and
                    more.
                  </p>
                </div>
                <div className="hero-card hero-panel-card-2">
                  <div className="panel-icon">🛒</div>
                  <h3>POS System</h3>
                  <p>
                    Fast checkout, inventory sync, and reporting for retail
                    teams.
                  </p>
                </div>
                <div className="hero-card hero-panel-card-3">
                  <div className="panel-icon">🌐</div>
                  <h3>E-commerce Website</h3>
                  <p>
                    Conversion-focused storefronts with smooth customer
                    journeys.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="section services-section" id="services">
            <div className="container">
              <div className="section-head" data-aos="fade-up">
                <p className="eyebrow">Services</p>
                <h2>Software services built to scale your business.</h2>
                <p className="section-copy">
                  From ERP and POS systems to mobile apps and custom solutions,
                  our team delivers polished software with performance and
                  speed.
                </p>
              </div>

              <div className="services-grid">
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="service-icon">📊</div>
                  <h3>ERP Software</h3>
                  <p>
                    Integrated planning and operations management for modern
                    teams.
                  </p>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="service-icon">💳</div>
                  <h3>POS System</h3>
                  <p>
                    Reliable sales workflows, inventory controls and customer
                    tracking.
                  </p>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="service-icon">🛍️</div>
                  <h3>E-commerce Website</h3>
                  <p>
                    Beautiful online stores built for conversion and fast
                    checkout.
                  </p>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <div className="service-icon">⚙️</div>
                  <h3>Custom Software</h3>
                  <p>
                    Tailored applications designed around your exact business
                    needs.
                  </p>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="service-icon">📱</div>
                  <h3>Mobile Apps</h3>
                  <p>
                    Engaging native and cross-platform apps for your customers.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="section why-section" id="why">
            <div className="container">
              <div className="section-head" data-aos="fade-up">
                <p className="eyebrow">Why Choose Us</p>
                <h2>Fast, affordable, custom software — backed by experts.</h2>
              </div>

              <div className="why-grid">
                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="why-icon">⚡</div>
                  <h3>Fast Delivery</h3>
                  <p>
                    Get your website or ERP ready quickly without sacrificing
                    quality.
                  </p>
                </div>
                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="why-icon">💰</div>
                  <h3>Affordable Pricing</h3>
                  <p>
                    Transparent estimates and scalable packages for every
                    budget.
                  </p>
                </div>
                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="why-icon">🛠️</div>
                  <h3>Custom Solutions</h3>
                  <p>
                    Software built to match your process, not the other way
                    around.
                  </p>
                </div>
                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <div className="why-icon">🕒</div>
                  <h3>24/7 Support</h3>
                  <p>
                    Reliable assistance anytime your project or product needs
                    help.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="section portfolio-section" id="portfolio">
            <div className="container">
              <div className="section-head" data-aos="fade-up">
                <p className="eyebrow">Portfolio</p>
                <h2 className="section-head portfolio_font">
                  Recent projects that showcase our craft.
                </h2>
              </div>

              <div className="portfolio-grid">
                <article
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <img
                    className="portfolio-image"
                    src="/img/WebVersionInventoryApp/Dashboard.png"
                    alt="Web Version Inventory Dashboard"
                  />
                  <div className="portfolio-copy">
                    <h3 className="portfolio_font">ERP Dashboard</h3>
                    <p className="portfolio_font">
                      Modern inventory dashboard built for analytics and process
                      control.
                    </p>
                  </div>
                </article>
                <article
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <img
                    className="portfolio-image"
                    src="/img/RestaurantInventoryApp/RestaurantPOS.png"
                    alt="Restaurant POS System"
                  />
                  <div className="portfolio-copy">
                    <h3 className="portfolio_font">Restaurant POS</h3>
                    <p className="portfolio_font">
                      Fast ordering and inventory management for restaurant
                      operations.
                    </p>
                  </div>
                </article>
                <article
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    className="portfolio-image"
                    src="/img/wordpress/anabiyahscollections.png"
                    alt="Anabiyah's Collections Website"
                  />
                  <div className="portfolio-copy">
                    <h3 className="portfolio_font">Anabiyah's Collections</h3>
                    <p className="portfolio_font">
                      Elegant WordPress storefront designed for fashion and
                      lifestyle brands.
                    </p>
                  </div>
                </article>
                <article
                  className="portfolio-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <img
                    className="portfolio-image"
                    src="/img/wordpress/agssons.png"
                    alt="Agssons Website"
                  />
                  <div className="portfolio-copy">
                    <h3 className="portfolio_font">Agssons Website</h3>
                    <p className="portfolio_font">
                      Professional WordPress showcase site with strong branding
                      and UX.
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </section>

          <section className="section testimonial-section" id="testimonials">
            <div className="container">
              <div className="section-head" data-aos="fade-up">
                <p className="eyebrow">Testimonials</p>
                <h2>What our clients say about working with MZR Software.</h2>
              </div>

              <div className="testimonial-grid">
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <p>
                    “MZR Software delivered an ERP solution in record time.
                    Their team was responsive, professional, and focused on
                    results.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Ali Khan</strong>
                    <span>Operations Head</span>
                  </div>
                </div>
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <p>
                    “The custom POS system transformed our store workflow. The
                    interface is intuitive and everything feels modern.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Sarah Malik</strong>
                    <span>Retail Manager</span>
                  </div>
                </div>
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <p>
                    “We launched our web presence fast, and the quality exceeded
                    expectations. Great service and excellent support.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Faizan R.</strong>
                    <span>Founder</span>
                  </div>
                </div>
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <p>
                    “Created a WordPress e-commerce store for
                    AnabiyahsCollections that turned out to be clean, fast, and
                    highly user-friendly. I was really impressed with both the
                    design and functionality”
                  </p>
                  <div className="testimonial-author">
                    <strong>AnabiyahsCollections</strong>
                    <span>WordPress Store Owner</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="final-cta-section" data-aos="fade-up">
            <div className="container final-cta-card">
              <div>
                <p className="eyebrow">Ready to grow your business?</p>
                <h2>Launch your next software project with MZR Software.</h2>
              </div>
              <Link to="/Contact/index" className="btn btn-primary btn-large">
                Start Your Project Now
              </Link>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}
